import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import { getTokenLogin } from 'utils/storage';
import "./index.scss";
import guideIcon01 from "images/home/guide_icon_01.png";
import guideIcon02 from "images/home/guide_icon_02.png";
import guideIcon03 from "images/home/guide_icon_03.png";
import guideIcon04 from "images/home/guide_icon_04.png";
import guideIcon05 from "images/home/guide_icon_05.png";
import guideIcon06 from "images/home/guide_icon_06.png";
import guideIcon07 from "images/home/guide_icon_07.png";

import guideIconcAtive01 from "images/home/guide_icon_01_cative.png";
import guideIconcAtive02 from "images/home/guide_icon_02_cative.png";
import guideIconcAtive03 from "images/home/guide_icon_03_cative.png";
import guideIconcAtive04 from "images/home/guide_icon_04_cative.png";
import guideIconcAtive05 from "images/home/guide_icon_05_cative.png";
import guideIconcAtive06 from "images/home/guide_icon_06_cative.png";
import shadowCenterImg from "images/home/shadow_center.png";

import guideIconcAtive07 from "images/home/guide_icon_07_cative.png";

export default class Entry extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    url: 'http://yhbest.imwork.net:38000',
                    img: guideIcon01,
                    active: guideIconcAtive01,
                    name: '综合信息数据库'
                },
                {
                    url: 'http://yhbest.imwork.net:38000',
                    img: guideIcon02,
                    active: guideIconcAtive02,
                    name: '统一应用支撑平台'
                },
                {
                    url: 'http://yhbest.imwork.net:38000',
                    img: guideIcon04,
                    active: guideIconcAtive04,
                    name: '综合事务管理平台'
                },
                {
                    url: '/entrance/home',
                    img: guideIcon03,
                    active: guideIconcAtive03,
                    name: '互联网+退役军人服务平台'
                },
                {
                    url: 'http://yhbest.imwork.net:38000/user/login',
                    img: guideIcon06,
                    active: guideIconcAtive06,
                    name: '退役军人服务中心管理平台'
                },
                {
                    url: 'http://121.31.6.5:8890/#/hainan/employment',
                    img: guideIcon05,
                    active: guideIconcAtive05,
                    name: '退役军人大数据平台'
                },
                {
                    url: 'http://yhbest.imwork.net:38000/user/login',
                    img: guideIcon07,
                    active: guideIconcAtive07,
                    name: '退役军人运营管理平台'
                },
            ]
        }
    }

    goPage(e) {
        window.open(e);
    }

    componentDidMount() {
        const token = getTokenLogin()
        console.log("token:", token)
    }

    handleClick = (index) => {
        var { list } = this.state;
        console.log("list:", list)
        var clickObj = list[index]
        var centerObj = list[3]
        console.log("centerObj:", centerObj)
        list[3] = clickObj;
        list[index] = centerObj;
        console.log("list:", list)
        this.setState({
            list: [...list]
        })
    }

    render() {
        let { list } = this.state;
        console.log("render-list:", list)
        return (

            <div className="guide_main">
                <div className="guide_container">
                    <div className="clear extraordinary">
                        {
                            list.map((item, index) => {
                                return (
                                    <div className="guide_link" key={index} onClick={() => this.handleClick(index)}>
                                        <a onClick={() => this.goPage(item.url)}>
                                            <div className="img_box">
                                                {
                                                    index == 3 ? <img src={item.active} /> : <img src={item.img} />
                                                }
                                            </div>

                                            <div className="txt">{item.name}</div>
                                            {
                                                index == 3 ?
                                                    <div className="shadow_center"><img src={shadowCenterImg} /></div>
                                                    : null
                                            }
                                        </a>

                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="show">
                        <div className="showIcon">
                            <div><div className="showIcon-txt">一张网</div></div>
                        </div>
                        <div className="showIcon">
                            <div><div className="showIcon-txt">一朵云</div></div>
                        </div>
                    </div>
                    <div className="codes">
                        <div className="code">
                            <div><div className="code-txt">退役军人APP</div></div>
                        </div>
                        <div className="code">
                            <div><div className="code-txt">关注微信公众号</div></div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}